import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-268d5ff4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "d-block text-center" }
const _hoisted_3 = { class: "plan-name text-dark fw-bold mb-4" }
const _hoisted_4 = { class: "text-gray-400" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-8" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "plan-name text-center"
}
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "d-block fs-6 mt-4 badge badge-light-primary w-50 mx-auto" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-8" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "key-features"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 title" }, "Key Features", -1))
const _hoisted_12 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($props.id)
      ? (_openBlock(), _createBlock(_component_Field, {
          key: 0,
          type: "radio",
          class: "btn-check",
          name: "plan",
          value: $props.id,
          id: $props.id
        }, null, 8, ["value", "id"]))
      : _createCommentVNode("", true),
    _createElementVNode("label", {
      for: $props.id,
      class: _normalizeClass(["p-7 p-lg-10 rounded pointer plan-card w-100", $props.customClass]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('selected')))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString($props.name), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString($props.detail), 1)
      ]),
      _hoisted_5,
      _renderSlot(_ctx.$slots, "default", {}, () => [
        ($props.price)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$filters.formatCurrency($props.price, "usd")), 1),
              _createElementVNode("small", _hoisted_8, [
                _createElementVNode("em", null, _toDisplayString($props.priceLabel), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ], true),
      _hoisted_9,
      ($props.keyFeatures?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.keyFeatures, (feature, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: ""
                }, _toDisplayString(feature.name), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1)
  ]))
}